<template>
  <LoadingContainer
    :is-loaded="isLoaded"
    :total="presetsLength"
    kind="Presets"
  >
    <ul class="activity-picker" slot="default">
      <li v-for="p in subjectPresets" :key="p.id">
        <ColorButton
          :color="subject.color"
          class="activity-picker__button"
          tag="router-link"
          :to="{
            name: 'new-preset-activity',
            params: {
              presetId: p.id
            }
          }"
        >
          [Preset] <b>{{ p.description }}</b>
        </ColorButton>
      </li>
      <li>
        <ColorButton
          :color="subject.color"
          class="activity-picker__button"
          tag="router-link"
          :to="{
            name: 'new-custom-activity',
            params: {
              subjectId: subject.id
            }
          }"
        >
          Custom <b>{{ subject.name }} Activity</b>
        </ColorButton>
      </li>
    </ul>

    <router-link
      slot="button"
      class="button button--border"
      :to="{
        name: 'settings-presets',
        query: {
          add: true
        }
      }"
      replace
    >
      Add Preset
    </router-link>
  </LoadingContainer>
</template>

<script>
import store from '@/store'
import { mapGetters } from 'vuex'

export default {
  name: 'ChoosePreset',

  computed: {
    ...mapGetters({
      areLoadedPresets: 'presets/isLoaded',
      presetsLength: 'presets/presetsLength',
      presets: 'presets/sortedPresets',
      areLoadedSubjects: 'subjects/isLoaded',
      subjects: 'subjects/sortedSubjects'
    }),

    isLoaded () {
      return this.areLoadedPresets && this.areLoadedSubjects
    },

    subjectId () {
      return this.$route.params.subjectId
    },

    subject () {
      const subject = this.subjects.find(s => s.id === this.subjectId)
      return subject || {}
    },

    subjectPresets () {
      if (!this.subjectId) return []

      const presets = this.subjectId
        ? this.presets.filter(p => {
          const subjectId = this.getPresetSubject(p.subject)
          return subjectId === this.subjectId
        })
        : this.presets

      return presets
    }
  },

  methods: {
    getPresetSubject (subject) {
      return Array.isArray(subject)
        ? subject[0]
        : subject
    },

    newActivity (preset) {
      this.$emit('activity', preset)
    }
  },

  mounted () {
    store.dispatch('presets/getPresets')
    store.dispatch('subjects/getSubjects')
  }
}
</script>

<style lang="scss" scoped>
.activity-picker {
  margin: 0;
  padding: 1rem 0;
  width: 100%;
  list-style: none;
}

li {
  margin-bottom: 1rem;
  width: 100%;
}
</style>
